import Cookies from 'js-cookie'
import RiotControl from 'riotcontrol'
import logger from '../logger'
import { get } from 'lodash-es'
import extendedObservable from './base'
import api from '../api'
import AjaxUtils from '../utils/ajax-utils'


// ////////////////
// Customer Info //
// ////////////////

export function CustomerInfo() {
  const orderResourceKey = 'customerInfo'

  extendedObservable(this, 'customerInfoModel')

  const successHandler = (json, status, xhr) => {
    logger('Success: Communicated with OP CustomerInfo Service - ', 'info')()
    logger(json, 'info')()

    this.model = json
    RiotControl.trigger('updateOrderResource', orderResourceKey, this.model)

    // update the order checksum
    const checksum = xhr.getResponseHeader('checksum')
    RiotControl.trigger('updateOrderChecksum', checksum)

    return this.model
  }

  const errorHandler = (xhr, status, errorThrown) => {
    logger(`Error: Failed to communicate with OP CustomerInfo Service - ${errorThrown}`, 'error')()
    logger(`Status: ${status}`, 'error')()
    logger(xhr, 'error')()

    // If checksum is invalid
    if (AjaxUtils.checkForBadChecksum(xhr)) {
      AjaxUtils.handleChecksumMismatch()
    }

    if (AjaxUtils.checkForNoOrder(xhr)) {
      AjaxUtils.handleNoOrder()
    }

    // If member number is invalid
    if (get(xhr, 'responseJSON.error["0"].code') === 50000) {
      return xhr
    }

    throw xhr
  }

  const createAccount = data => new Promise((resolve, reject) =>
    api.user.register(this.orderModel.safeGet('orderId'), data)
      .then(resolve)
      .catch(reject))

  this.on('reverseMembershipLookup', (cb, errorCb) => {
    api.customer.put(JSON.stringify({}))
      .then(successHandler)
      .then(cb)
      .fail(errorHandler)
      .fail(errorCb)
  })

  this.on('membershipLookup', (memberNumber, cb, errorCb) => {
    const lookupObj = JSON.stringify({ memberNumber })
    api.customer.put(lookupObj)
      .then(successHandler)
      .then(cb)
      .fail(errorHandler)
      .fail(errorCb)
  })

  this.on('toggleDividend', (cb) => {
    const currentDividendState = this.model.dividendOptOut
    const memberNumber = this.model.memberNumber
    const sendObj = JSON.stringify({
      memberNumber,
      dividendOptOut: !currentDividendState,
    })

    api.customer.put(sendObj)
      .then(successHandler)
      .then(cb)
      .fail(errorHandler)
  })

  this.on('getContactInfo', (cb) => {
    logger('getContactInfo', 'debug')()
    api.billingAddress.get()
      .then(successHandler)
      .then(cb)
      .fail(errorHandler)
  })

  this.on('update', (data) => {
    if (this.model !== data.orderModel[orderResourceKey]) {
      this.model = data.orderModel[orderResourceKey]
    }
  })

  this.on('createAccount', (data, cb, err) => {
    createAccount(data)
      .then(cb)
      .catch(err)
  })

  this.on('getCustomerAttributes', (cb, err) => {
    const mcvIdCookie = Cookies.get('AMCV_F0A65E09512D2C440A490D4D@AdobeOrg')
    const cookieErrorCb = (statusText) => err({ statusText })

    if (mcvIdCookie) {
      const mcvidCookieVal = /MCMID\|(\d+)/.exec(mcvIdCookie)
      const mcvId = mcvidCookieVal && mcvidCookieVal[1]

      if (mcvId) return api.customerAttributes.get(mcvId).then(cb).catch(err)
      
      return cookieErrorCb('mcvId value not found') 
    }
      
    return cookieErrorCb('Cookie not found')
  })
}
